import { Splide } from '@splidejs/splide';

const Slider = {

	templateSitesSlidesConfig: {
		type: 'loop',
		gap: '4.375rem',
		perPage: 1,
		breakpoints: {
			576: {
				gap: '10rem',
			},
		}
	},

	ourPeopleConfig: {
		type: 'loop',
		perPage: 4,
		arrows: false,
		pagination: false,
		gap: '1rem',
		breakpoints: {
			576: {perPage: 1},
			992: {perPage: 2},
			1200: {perPage: 3}
		}
	},

	/**
	 * @param {HTMLElement} element
	 */
	init: function (element) {
		const settings = element.dataset.sliderType === 'template-sites'
			? Slider.templateSitesSlidesConfig
			: Slider.ourPeopleConfig;

		const slider = new Splide(element.querySelector('.splide'), settings);
		slider.mount();

		const nextBtn = element.querySelector('[data-slider-control="next"]');
		nextBtn.addEventListener('click', function () {
			slider.go('>');
		});

		const prevBtn = element.querySelector('[data-slider-control="previous"]');
		prevBtn.addEventListener('click', function () {
			slider.go('<');
		});

	}

};

export default Slider;
